import React from "react";
import { formatBytes } from "../../../../Helpers/Chat/ChatHelper";

const PreviewDocument = (props = {}) => {

    const {  media: { name = "", size = "" } = {}, placeholder = "" } = props;
    const updateSize = formatBytes(size);
    /**
    // React.useEffect(() => {
    //     updateMedia(props.media, {
    //         msgType: "file"
    //     });
    // }, []);
    */

    return (
        <React.Fragment>
            <div className="type-image document">
                <div className="type-thumb-image">
                    <img src={placeholder} alt="" />
                    <p>{`${name} , ${updateSize}`}</p>
                </div>
            </div>
        </React.Fragment>
    );
}

export default PreviewDocument;
